// eslint-disable-next-line @typescript-eslint/naming-convention
enum LOCAL_STORAGE_KEYS {
  TOKEN = 'tat-local',
  CLEAR = 'trpat,trptkn,token',
}

export default LOCAL_STORAGE_KEYS;
